
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat" 
             style={{
               backgroundImage: `linear-gradient(rgba(92, 26, 36, 0.7), rgba(92, 26, 36, 0.7)), url('https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/6bf1b71390550737efa344fa55a21d98.jpeg')`
             }}>
      <div className="container mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Transforme sua ideia em um projeto de alto padrão.
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 font-light">
            Cada grande projeto começa com uma boa conversa.
          </p>
          
          <div className="max-w-3xl mx-auto">
            <p className="text-lg md:text-xl leading-relaxed mb-8">
              Oferecemos um atendimento próximo, técnico e eficiente, pensado para quem busca qualidade, exclusividade e tranquilidade em todas as etapas.
            </p>
          </div>

          <div className="mt-8">
            <a
              href="https://api.whatsapp.com/send/?phone=5511980341891&text=Ol%C3%A1%21+Gostaria+de+saber+mais+sobre+os+servi%C3%A7os+da+P&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-[#5C1A24] text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#4A1520] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-3 text-xl"></i>
              Solicite um orçamento
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
